export const Tokens = {
    Resends: Symbol('Resends'),
    Subscriber: Symbol('Subscriber')
};
//# sourceMappingURL=tokens.js.map